<template lang="pug">
div
    label Grid color
    vue-swatches(@input="onInput", :value="value", colors="text-advanced")
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
    },

    methods: {
        onInput(color) {
            this.$emit('input', color);
        },
    },
};
</script>

<style lang="scss" scoped>
label {
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-color-picker.vue